import React, {Component} from 'react';
import Photo from '../images/profil.jpg';
class logo extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="flex flex-wrap relative mt-6 pt-6">
                <div className="w-full text-center mb-3">
                    <img src={Photo} className="m-auto shadow-lg rounded-tl-lg rounded-br-lg" width="50%"/>
                </div>
                <div className="w-full">
                    <span className="block text-3xl">Kemal <span className="font-bold">Aydın</span></span>
                    <span className="text-xs text-gray-900">🚀 Software Developer</span>
                </div>
            </div>
        );
    }
}

export default logo;